import rexps from './regexps.js';
import _ from 'lodash';

export function latitude(value) {

    if (_.isNull(value) || _.isUndefined(value) || value.length === 0) {
        return true;
    }

    if (!rexps.float.test(value)) {
        return false;
    }

    const latitude = parseFloat(value);

    if (latitude < -90 || latitude > 90) {
        return false;
    }

    return true;
}

export function longitude(value) {

    if (_.isNull(value) || _.isUndefined(value) || value.length === 0) {
        return true;
    }

    if (!rexps.float.test(value)) {
        return false;
    }


    const longitude = parseFloat(value);

    if (longitude < -180 || longitude > 180) {
        return false;
    }

    return true;
}
